import { render } from "./PaneRow.vue?vue&type=template&id=0d28d8f0&scoped=true"
import script from "./PaneRow.vue?vue&type=script&lang=js"
export * from "./PaneRow.vue?vue&type=script&lang=js"

import "./PaneRow.vue?vue&type=style&index=0&id=0d28d8f0&scoped=true&lang=scss"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d28d8f0"]])

export default __exports__